import React from 'react'
import './student-badge.css'
import { MdOutlineSchool, MdOutlineCalendarMonth } from 'react-icons/md'
import { addDays, differenceInYears, isAfter } from 'date-fns'
import IntroLessonToolTip from './IntroLessonToolTip/IntroLessonToolTip'

const StudentBadge = ({ student, familyInfo, scheduledEvents }) => {
    const [studentDatabaseInfo, setStudentDatabaseInfo] = React.useState(false)
    const [introLessonInfo, setIntroLessonInfo] = React.useState(false)
    const [toolTip, setToolTip] = React.useState(false)

    React.useEffect(() => {
        scheduledEvents.map((event) => {
            familyInfo.students.map((dbStudent) => {
                if(event.studentId === dbStudent.studentId && !event.isPendingOffer && isAfter(new Date(event.dateTime), addDays(new Date(), -5))) {
                    setIntroLessonInfo(event)
                }
            })
        })
    }, [])
    
    React.useEffect(() => {
        (familyInfo && studentDatabaseInfo === false) && findStudentDatabaseInfo()
    }, [familyInfo])

    const findStudentDatabaseInfo = () => {
        if(familyInfo) {
            let studentDatabaseInfo = familyInfo?.students.find((dbStudent) => dbStudent.studentName.replace(/\s/g, '') === student.studentName.replace(/\s/g, ''))
            setStudentDatabaseInfo(studentDatabaseInfo)
        }
    }

    const checkIfLessonIsInCalendar = (scheduledEvents, students, yesColor, noColor) => {
        let scheduled = noColor
        scheduledEvents.map((event) => {
            students.map((dbStudent) => {
                if(event.studentId === dbStudent.studentId && !event.isPendingOffer && isAfter(new Date(event.dateTime), addDays(new Date(), -5))) {
                    scheduled = yesColor
                }
            })
        })
        return scheduled
    }


    return (
        <div className='student-badge'>
            {toolTip && introLessonInfo && <IntroLessonToolTip introLessonInfo={introLessonInfo} />}
            <div className='student-badge__name-section'>
                <div className='student-badge__name-section__icon-wrapper'>
                    <MdOutlineSchool size={20} color='#475569' />
                </div>
                <div className='student-badge__name-section__name-age-experience'>
                    <div className='student-badge__name'>{student?.studentName} {familyInfo?.familyName}</div>
                    {studentDatabaseInfo && <div className='student-badge__age-experience'>{studentDatabaseInfo.dob && differenceInYears(new Date(), new Date(studentDatabaseInfo.dob))} Years Old | {studentDatabaseInfo.lessonLength} min | {studentDatabaseInfo.experienceLevel && studentDatabaseInfo.experienceLevel}</div>}
                </div>
                {student.introLesson && 
                <div className='student-badge__name-section__calendar-icon-wrapper' onMouseEnter={() => setToolTip(true)} onMouseLeave={() => setToolTip(false)} style={{backgroundColor: checkIfLessonIsInCalendar(scheduledEvents, familyInfo.students, '#CCFBF1', '#FEE2E2')}}>
                    <MdOutlineCalendarMonth color={checkIfLessonIsInCalendar(scheduledEvents, familyInfo.students, '#0D9488', '#DC2626')} size={14} />
                </div>
                }
            </div>
            <div className='student-badge__instrument-section'>
                {student.instrumentList.map((instrument, index) => <div key={index} className='student-badge__instrument-chip'>{instrument.name}</div>)}
            </div>
        </div>
    )
}
export default StudentBadge